<template>
  <div
    class="mdl-card mdl-shadow--2dp"
    style="margin-top: 1em;">
    <div class="mdl-card__title locked">
      {{ qnResponseSingle.card_title }}
    </div>
    <div class="mdl-card__supporting-text">
      <i class="lock icon"/>
      Unlocks after {{ answerDiff }} more <span v-if="answerDiff > 1">survey answers</span> <span v-else>survey answer</span>
    </div>
  </div>
</template>

<script>
// FIXME: HTML needs translations
export default {
  name: 'LockedSurvey',
  props: {
    answeredCount: {
      type: Number,
      required: true
    },
    qnResponseSingle: {
      type: Object,
      required: true
    },
    formId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    };
  },
  computed: {
    answerDiff: function () {
      return this.$vnode.key - this.answeredCount;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/survey/onetime/LockedSurvey.vue